/**
 * Track open tabs so Remember Me only auto-restores after a full browser restart,
 * not when the user opens an additional tab while another session is already active.
 */

const HEARTBEAT_KEY = 'jetscanner_tab_heartbeats';
const TAB_ID_KEY = 'jetscanner_tab_id';
const HEARTBEAT_INTERVAL_MS = 2000;
const STALE_MS = 5000;

let heartbeatTimer = null;

const getTabId = () => {
  let id = sessionStorage.getItem(TAB_ID_KEY);
  if (!id) {
    id = `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
    sessionStorage.setItem(TAB_ID_KEY, id);
  }
  return id;
};

const readHeartbeats = () => {
  try {
    return JSON.parse(localStorage.getItem(HEARTBEAT_KEY) || '{}');
  } catch {
    return {};
  }
};

const writeHeartbeats = (beats) => {
  localStorage.setItem(HEARTBEAT_KEY, JSON.stringify(beats));
};

const pruneHeartbeats = (beats) => {
  const now = Date.now();
  const pruned = {};
  for (const [id, ts] of Object.entries(beats)) {
    if (now - ts < STALE_MS) {
      pruned[id] = ts;
    }
  }
  return pruned;
};

/** True when another tab recently reported itself as open. */
export const hasOtherLiveTabs = () => {
  const tabId = getTabId();
  const beats = pruneHeartbeats(readHeartbeats());
  return Object.keys(beats).some((id) => id !== tabId);
};

export const touchTabHeartbeat = () => {
  const tabId = getTabId();
  const beats = pruneHeartbeats(readHeartbeats());
  beats[tabId] = Date.now();
  writeHeartbeats(beats);
};

export const removeTabHeartbeat = () => {
  const tabId = getTabId();
  const beats = pruneHeartbeats(readHeartbeats());
  delete beats[tabId];
  writeHeartbeats(beats);
};

export const startLiveTabHeartbeat = () => {
  stopLiveTabHeartbeat();
  touchTabHeartbeat();
  heartbeatTimer = setInterval(touchTabHeartbeat, HEARTBEAT_INTERVAL_MS);
  window.addEventListener('pagehide', removeTabHeartbeat);
};

export const stopLiveTabHeartbeat = () => {
  if (heartbeatTimer) {
    clearInterval(heartbeatTimer);
    heartbeatTimer = null;
  }
  window.removeEventListener('pagehide', removeTabHeartbeat);
  removeTabHeartbeat();
};
